export default function () {
  return {
    errorMsg: "",
    activeError: false,
  }
}
